import axios from 'axios'
import * as Sentry from '@sentry/react'

const api = axios.create({
  baseURL:
    process.env.REACT_APP_API_URL ||
    'https://wms-be.staging.bahteraadijaya.com/api/',
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${localStorage.getItem('token')}`
  }
})

api.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    const status = error.response?.status
    if (status && status >= 500) {
      Sentry.captureException(error, {
        extra: {
          url: error.config?.url,
          method: error.config?.method,
          status: status,
          responseData: error.response?.data
        }
      })
    }
    return Promise.reject(error)
  }
)

export default api
